<template>

    <header id="header" class="navbar navbar-dark sticky-top flex-md-nowrap child">
        <a id="logo-link" class="navbar-brand col-md-3 col-lg-2 me-0" href="/">
            <img id="logo-1" src="/themes/web/assets/images/logo.png" alt="">
        </a>

        <!-- <div class="header-help">
            <router-link :to="{ name: 'home' }" @click.native="getSoundClick" class="nav-link">
                <button class="btn btn-return-faq">
                    <i class="lisa-icon-faq-return"></i> {{$t('lisa_web_return_to_lisa')}}
                </button>
            </router-link>
        </div> -->
    </header>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { getConfigs, getLanguage, soundClick } from "../utils/utils";

export default {
    name: "NavBarFaq",

    data() {
        const configs = getConfigs();
        const locate = getLanguage();
        const localizes = configs.localize || [];

        let locate_info = {};
        localizes.forEach(item => {
            if(item.lang == locate){
                locate_info = item;
            }
        });
                
        return {
            locate: getLanguage(),
            locate_info: locate_info,
            configs: configs,
            localizes: localizes,
            search: '',
        };
    },

    computed: {
        user() {
            return this.$store.state.user_info;
        },
    },

    created() {
        this.fetch();
    },
    mounted() {
        if(this.$route.query.keyword){
            this.search = this.$route.query.keyword;
        }
    },
    methods: {
        fetch() {
            this.user.grade = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user.grade;
        },

        onLogout(e) {
            this.$store.dispatch('logout').then(() => {
                localStorage.removeItem("grade");
                window.location.href = "/login";
            });
            // localStorage.removeItem('grade');
            e.preventDefault();
        },

        gotoDailyChallenge() {
            //window.location.href = '/daily-challenge';

            this.$router.push({ name: 'daily_challenge' })
        },

        getSoundClick() {
            soundClick();
        },

        handleSubmit(){
            // const path = `/search/${this.search}`
            this.$router.push({
                path: "/search",
                query: {
                    keyword: this.search,
                    t: new Date().getTime(),
                }
            });
        }
    }
}
</script>

<style scoped>
    #logo-1{
        /* height: 115px; */
        width: 100%;
    }
</style>
